import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import compose from 'lodash.flowright';

import ScrollableDiv from '../../ScrollableDiv';
import IdentitySelectorAvatar from './IdentitySelectorAvatar';
import { setActiveIdentity as setActiveIdentityAction } from '../../../../services/checkout/redux/checkoutActions';
import { getItemsCountByIdentity } from '../helpers';
import PlusIcon from '../../../icons/PlusIcon';
import Button from '../../Button';

const propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func,
  }).isRequired,
  match: PropTypes.shape({
    params: PropTypes.shape({
      albumFolderId: PropTypes.string.isRequired,
    }),
  }).isRequired,
  cart: PropTypes.array.isRequired,
  identities: PropTypes.array.isRequired,
  activeIdentity: PropTypes.shape({
    id: PropTypes.string.isRequired,
  }),
  setActiveIdentity: PropTypes.func.isRequired,
  onAddFace: PropTypes.func,
  isOnboarding: PropTypes.bool,
};

const IdentitySelector = ({
  history,
  match,
  cart,
  identities,
  activeIdentity,
  setActiveIdentity,
  onAddFace,
  isOnboarding,
}) => {
  const { albumFolderId } = match.params;

  useEffect(() => {
    const activeIdentityIsInIdentities = !!(identities ?? []).find(entity =>
      isOnboarding
        ? entity.id === activeIdentity?.id
        : (entity.identity.id === entity.id) === activeIdentity?.id,
    );

    if (
      (identities && !activeIdentity) ||
      (identities && !activeIdentityIsInIdentities)
    ) {
      const entity = isOnboarding ? identities[0] : identities[0]?.identity;
      setActiveIdentity(entity);
    }
  }, [identities]);

  if (!identities) {
    return null;
  }

  return (
    <div className="prepaid-items-identity-selector">
      {onAddFace && (
        <Button
          btnStyle="link"
          className="d-flex flex-column align-items-center mr-1"
          onClick={() => {
            onAddFace();
            history.push(`/discover/album-folder/${albumFolderId}/faces`);
          }}
        >
          <div className="prepaid-items-identity-selector-new">
            <PlusIcon color="white" size={24} />
          </div>
          <p className="mb-0 text-xs text-extra-bold text-primary mt-1">Add</p>
        </Button>
      )}
      <ScrollableDiv orientation="horizontal">
        <div className="identity-selector-container">
          {identities.map(identity => {
            // If we are not within onboarding, we're using a membership's identity.
            const entity = isOnboarding ? identity : identity.identity;
            const identitySelectedItems = getItemsCountByIdentity(cart, entity);

            return (
              <IdentitySelectorAvatar
                key={entity.id}
                identity={entity}
                onClick={() => {
                  setActiveIdentity(entity);
                }}
                isActive={entity.id === activeIdentity?.id}
                itemsCount={identitySelectedItems}
                isShared={!identity.is_owner}
              />
            );
          })}
        </div>
      </ScrollableDiv>
    </div>
  );
};

IdentitySelector.propTypes = propTypes;

const mapStateToProps = ({ checkout }) => ({
  cart: checkout.cart,
  activeIdentity: checkout.activeIdentity,
});

const mapDispatchToProps = {
  setActiveIdentity: setActiveIdentityAction,
};

export default compose(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps),
)(IdentitySelector);
